import { render, staticRenderFns } from "./ContentPagesList.vue?vue&type=template&id=649bd954"
import script from "./ContentPagesList.vue?vue&type=script&lang=js"
export * from "./ContentPagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports